/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Complete/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Complete({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress/ProgressBarIndicator/Complete"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Please review the following and click here to confirm."
/>
{children}
</React.Fragment>)
}